import React from "react";
import styled from "styled-components";
import { Modal } from "@redq/reuse-modal";
import t from '../i18n/translate';
import delishopOnlineSupportIMG from '../assets/images/delishop-online-support_s2.jpg';
import telegramQRCodeIMG from '../assets/images/telegram-qrcode.png';

const Heading = styled.h3`
  font-size: 21px;
  font-weight: 700;
  color: #0d1136;
  line-height: 1.2;
  margin-bottom: 25px;
  width: 100%;
  text-align: center;
`;

const HelpPageWrapper = styled.div`
  background-color: #f7f7f7;
  position: relative;
  padding: 130px 0 60px 0;
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 989px) {
    padding-top: 70px;
  }
`;

export const HelpPageContainer = styled.div`
  background-color: transparent;
  padding: 0;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
  
  p { margin-bottom: 5px; }
  
  @media (min-width: 990px) {
    width: 870px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (max-width: 989px) {
    padding: 30px;
  }
`;

export default function ContactScreen() {
  return (
    <Modal>
      <HelpPageWrapper>
        <HelpPageContainer>
          <Heading>{ t('contact_us_title') }</Heading>
          
          <p><b>{ t('contact_us_delishop_asia') }</b></p>
          <p>{ t('contact_us_address_label') }</p>
          <p>{ t('contact_us_phone_label') } : { t('contact_us_phone_value') }</p>
          <p>{ t('contact_us_email_label') } <a href="mailto: contact@delishop.asia">contact@delishop.asia</a></p><br/>

          <p>{ t('contact_us_scan_me_to_chat_with_our_operators_on_telegram_label') }</p>
          <p>{ t('contact_us_telegram_label') } : <a href="https://t.me/DelishopContactBot" target="_blank">https://t.me/DelishopContactBot</a></p>
          <img src={telegramQRCodeIMG}
               alt="Delishop telegram"
               style={{
                 width: 'auto',
                 height: '100%',
                 maxHeight: 600,
                 display: 'block',
                 marginTop: 5
               }}
          />
          <br/><br/>

          <p>{ t('contact_us_facebook_page_label') } : <a href="https://www.facebook.com/Delishop.asia" target="_blank">https://www.facebook.com/Delishop.asia</a></p><br/>

          <p><b>{ t('contact_us_directly_on_chat_through_the_website') }</b></p>
          <p>
            <img src={delishopOnlineSupportIMG}
                  alt="Delishop online support"
                  style={{
                    width: 'auto',
                    height: '100%',
                    maxHeight: 600,
                    display: 'block',
                    marginTop: 5
                  }}
            />
          </p>
 
        </HelpPageContainer>
      </HelpPageWrapper>
    </Modal>
  );
}
